import Flickity from 'flickity';

import {register} from '../vendor/theme-scripts/theme-sections';
import {Ticker} from '../features/ticker';

const selectors = {
  bar: '[data-bar]',
  barSlide: '[data-slide]',
  frame: '[data-ticker-frame]',
  slider: '[data-slider]',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
};

const attributes = {
  slide: 'data-slide',
  speed: 'data-slider-speed',
  stop: 'data-stop',
  style: 'style',
  dataTargetReferrer: 'data-target-referrer',
};

const classes = {
  desktop: 'desktop',
  mobile: 'mobile',
  tickerAnimated: 'ticker--animated',
};

const sections = {};

class AnnouncementBar {
  constructor(container) {
    this.barHolder = container;
    this.locationPath = location.href;
    this.slides = this.barHolder.querySelectorAll(selectors.barSlide);
    this.slider = this.barHolder.querySelector(selectors.slider);
    this.flkty = null;

    this.init();
  }

  init() {
    this.removeAnnouncement();

    if (this.slider) {
      this.initSlider();
      document.addEventListener('theme:resize:width', this.initSlider.bind(this));
    }

    if (!this.slider) {
      this.initTickers(true);
    }
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let i = 0; i < this.slides.length; i++) {
      const element = this.slides[i];

      if (!element.hasAttribute(attributes.dataTargetReferrer)) {
        continue;
      }

      if (this.locationPath.indexOf(element.getAttribute(attributes.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Init slider
   */
  initSlider() {
    const slides = this.slider.querySelectorAll(selectors.barSlide);

    if (slides) {
      let slideSelector = `${selectors.barSlide}`;

      if (window.innerWidth < theme.sizes.small) {
        slideSelector = `${selectors.barSlide}:not(.${classes.desktop})`;
      } else {
        slideSelector = `${selectors.barSlide}:not(.${classes.mobile})`;
      }

      if (this.flkty != null) {
        this.flkty.destroy();
      }

      this.flkty = new Flickity(this.slider, {
        cellSelector: slideSelector,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: parseInt(this.slider.getAttribute(attributes.speed), 10),
        on: {
          ready: () => {
            setTimeout(() => {
              this.slider.dispatchEvent(
                new CustomEvent('slider-is-loaded', {
                  bubbles: true,
                  detail: {
                    slider: this,
                  },
                })
              );
            }, 10);
          },
        },
      });
      this.flkty.reposition();
    }

    this.slider.addEventListener('slider-is-loaded', () => {
      this.initTickers();
    });
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frames = this.barHolder.querySelectorAll(selectors.frame);

    frames.forEach((element) => {
      new Ticker(element, stopClone);

      const slides = element.querySelectorAll(selectors.barSlide);
      if (slides.length !== 0) {
        const slidesMobile = element.querySelectorAll(`${selectors.barSlide}.${classes.mobile}`);
        const slidesDesktop = element.querySelectorAll(`${selectors.barSlide}.${classes.desktop}`);

        if (slides.length === slidesMobile.length) {
          element.parentNode.classList.add(classes.mobile);
        } else if (slides.length === slidesDesktop.length) {
          element.parentNode.classList.add(classes.desktop);
        }
      }
    });
  }

  toggleTicker(e, isStoped) {
    const tickerScale = e.target.closest(selectors.tickerScale);
    const element = document.querySelector(`[${attributes.slide}="${e.detail.blockId}"]`);

    if (isStoped && element) {
      tickerScale.setAttribute(attributes.stop, '');
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.remove(classes.tickerAnimated);
        textHolder.style.transform = `translate3d(${-(element.offsetLeft - parseInt(getComputedStyle(element).marginLeft, 10))}px, 0, 0)`;
      });
    }

    if (!isStoped && element) {
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.add(classes.tickerAnimated);
        textHolder.removeAttribute(attributes.style);
      });
      tickerScale.removeAttribute(attributes.stop);
    }
  }

  onBlockSelect(evt) {
    const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));

    if (this.slider && this.flkty !== null) {
      this.flkty.select(index);
      this.flkty.pausePlayer();
    }
    if (!this.slider) {
      this.toggleTicker(evt, true);
    }
  }

  onBlockDeselect(evt) {
    if (this.slider && this.flkty !== null) {
      this.flkty.unpausePlayer();
    }
    if (!this.slider) {
      this.toggleTicker(evt, false);
    }
  }

  onUnload() {
    document.removeEventListener('theme:resize:width', this.initSlider.bind(this));
  }
}

const bar = {
  onLoad() {
    sections[this.id] = [];
    const element = this.container.querySelector(selectors.bar);
    if (element) {
      sections[this.id].push(new AnnouncementBar(element));
    }
  },
  onBlockSelect(e) {
    if (sections[this.id].length) {
      sections[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockSelect(e);
        }
      });
    }
  },
  onBlockDeselect(e) {
    if (sections[this.id].length) {
      sections[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === 'function') {
          el.onBlockDeselect(e);
        }
      });
    }
  },
};

register('announcement-bar', bar);
register('marquee', bar);
